import { Author, Image, SeoMeta } from "queries/Base";
import { Cta2Record, MediaRecord } from "queries/Blocks";
import { EnumType } from "json-to-graphql-query";

export const getAllBlogPostsSlugs = {
    allBlogPosts: {
        __args: {
            first: 100,
        },
        slug: true
    }
};

export const BlogQuery = {
    id: true,
    title: true,
    slug: true,
    featuredImage: {
        ...Image
    },
    author: {
        ...Author
    },
    categories: {
        name: true
    },
    readTime: true,
    intro: {
        value: true
    },
    content: {
        value: true,
        blocks: {
            __typename: true,
            __on: [
                ...MediaRecord,
                ...Cta2Record
            ]
        }
    }
};

export const getBlogPosts = (locale: string, limit = 10, skip = 0) => {
    return {
        allBlogPosts: {
            __args: {
                first: limit,
                skip: skip,
                locale: new EnumType(locale),
                filter: {
                    slug: {
                        //@ts-ignore
                        neq: null
                    },
                    title: {
                        isBlank: ""
                    }
                }
            },
            ...BlogQuery,
        },
        blog: {
            __args: {
                locale: new EnumType(locale)
            },
            ...SeoMeta
        }
    };
};

export const getBlogPostBySlug = (slug: string, locale: string, locales: string[] = []) => ({
    blogPost: {
        __args: {
            filter: {
                slug: { eq: slug },
            },
            locale: new EnumType(locale),
            fallbackLocales: locales.map((locale) => new EnumType(locale))
        },
        ...BlogQuery,
        ...SeoMeta,
        relatedBlogPosts: BlogQuery,
        _locales: true
    }
});

